"use client";

import store from "@/store/store";
import { LogoSizes } from "@/types/enums";
import { useEffect, useLayoutEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Department, Global } from "../../lib/directus-schema";
import Logo from "../ui/Logo";
import Footer from "../ui/texts/Footer";
import Image from "next/image";
import { useRouter } from "next/navigation";
import Dropdown from "../ui/Dropdown";
import { motion } from "motion/react";

type Props = {
    initialGlobal: Global | null;
    customerSlug: string;
    departments: Department[];
};

const CustomerClient = observer(function CustomerClient({
    initialGlobal,
    departments,
}: Props) {
    const router = useRouter();
    const [selectedDepartmentId, setSelectedDepartmentId] = useState<number | null>(null);
    const [isRootVisible, setIsRootVisible] = useState(false);

    useLayoutEffect(() => {
        store.globalData = initialGlobal;
    }, [initialGlobal]);

    useEffect(() => {
        let raf1 = 0;
        let raf2 = 0;

        raf1 = window.requestAnimationFrame(() => {
            raf2 = window.requestAnimationFrame(() => {
                setIsRootVisible(true);
            });
        });

        return () => {
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, []);

    const options: { label: string; value: number }[] = departments.map((department) => ({
        label: department.name,
        value: department.id,
    }));

    const handleDepartmentChange = (departmentId: number) => {
        const selectedDepartment = departments.find((department) => department.id === departmentId);
        if (!selectedDepartment?.slug) return;

        setSelectedDepartmentId(departmentId);
        store.setSelectedDepartment(selectedDepartment.slug);
        router.push(`/${encodeURIComponent(selectedDepartment.slug)}`);
    };

    return (
        <motion.div
            className="flex flex-col justify-start items-center gap-6 px-4 w-svw h-svh text-center"
            initial={false}
            animate={{ opacity: isRootVisible ? 1 : 0 }}
            transition={isRootVisible ? { duration: 0.35, ease: "easeOut" } : { duration: 0 }}
        >
            <div className="flex flex-col justify-center items-center px-4 pt-8 w-full">
                <Logo size={LogoSizes.LARGE} />
                <div className="w-71.25 h-9.5">
                    <Image
                        src={"/images/CustomerClaim.png"}
                        alt="Logo"
                        width={285}
                        height={38}
                        className="object-cover"
                    />
                </div>
            </div>
            <div className="flex flex-col gap-3 mt-8 w-full max-w-150">
                <p className="font-14-bold text-green-800">Unsere neue Schulung ist jetzt ein Game.</p>
                <Dropdown
                    openTop={false}
                    placeholder={"Wähle deine Abteilung"}
                    options={options}
                    value={selectedDepartmentId}
                    onChange={handleDepartmentChange}
                />
            </div>
            <div className="bottom-0 absolute flex flex-col justify-center items-center gap-2.5 px-4 w-full max-w-150">
                <Footer />
            </div>
        </motion.div>
    );
});

export default CustomerClient;
